var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.url ? 'a' : 'button',{tag:"component",attrs:{"data-component":"button","href":_vm.url || false,"type":_vm.url ? false : _vm.type},on:{"click":_vm.clicked}},[_vm._t("default",function(){return [_vm._v("Button")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }